import React from "react";
import { Grid, Heading, Poster, VerticalSpacing, VerticalSpacingSizes } from "../../../../";
import { Section } from "../../../../elements/Section";
import { types } from "../../../../elements/Heading";
import { Rank } from "../../../../core";
/* eslint-disable camelcase */

/* eslint-disable @typescript-eslint/camelcase */

var Header = function Header(_ref) {
  var product_image = _ref.product_image,
      product_title = _ref.product_title,
      tagline = _ref.tagline,
      starting_price = _ref.starting_price,
      starting_price_prepend = _ref.starting_price_prepend;
  return /*#__PURE__*/React.createElement(Section, {
    fullWidth: true,
    background: "grayDark"
  }, /*#__PURE__*/React.createElement(Poster, {
    height: "xs",
    imageSrc: product_image
  }, /*#__PURE__*/React.createElement(Grid, {
    variant: "3/4,1/4",
    gutterlessAtNarrow: true
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement(Heading, {
    type: types.ExtraLarge,
    rank: Rank.First
  }, /*#__PURE__*/React.createElement("strong", null, product_title))), /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.S
  }, /*#__PURE__*/React.createElement(Heading, {
    type: types.Medium,
    rank: Rank.Second
  }, tagline)), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, starting_price_prepend, " ", starting_price))))));
};

Header.displayName = "Header";
export default Header;